export function convertToUserTimezone(dateTimeToConvert: string): string {
  const date = new Date(dateTimeToConvert);
  // Get user timezone in minutes
  const offsetMinutes = date.getTimezoneOffset();

  // Shift the date by the offset (in the opposite direction)
  date.setMinutes(date.getMinutes() - offsetMinutes);

  // Extract the original fractional seconds, if any
  const match = dateTimeToConvert.match(/\.(\d+)(Z|[+-]\d{2}:?\d{2})?$/);
  let iso: string;
  if (match) {
    // Keep fractional seconds and add single Z
    const base = date.toISOString().replace(/\.\d+Z$/, "");
    iso = base + "." + match[1] + "Z";
  } else {
    // Or just get ISO string
    iso = date.toISOString();
  }

  return iso;
}
